import { useEffect } from "react";

import { useIntl } from "gatsby-plugin-react-intl";
import { useDispatch } from "react-redux";

import errorHelper from "./errorHelper";
import { setSspRegistrationData } from "../features/sspRegistrationSlice";
import { notificationService } from "../services/notification.service";

const useSignUpPasswordResponseHelper = (submitSspUserResult) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const error = errorHelper(submitSspUserResult.error);

  const identifier = submitSspUserResult?.data?.identifier;

  useEffect(() => {
    if (submitSspUserResult.isSuccess && identifier) {
      dispatch(setSspRegistrationData({
        identifier: submitSspUserResult.data.identifier,
      }));
    }

    if (submitSspUserResult.isSuccess && !identifier) {
      notificationService.error(intl.formatMessage({ id: "error.payload_missing" }));
    }

    if (submitSspUserResult.isError) {
      notificationService.error(
        (error.status >= 400)
          ? intl.formatMessage({ id: "error.signup_password_error" }, { error: error.message, status: error.status })
          : intl.formatMessage({ id: "io.error.default_title" }),
      );
    }
  }, [submitSspUserResult]);
};

export default useSignUpPasswordResponseHelper;
